import LOADER from '@ott/utility-loader';
import * as T from './types';

const initialState = {
  isTestResponse: false,
  pickUp: {
    points: [],
    status: LOADER.initial(),
    selectedPoint: {},
  },
  dropOff: {
    points: [],
    status: LOADER.initial(),
    selectedPoint: {},
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case T.SUGGEST_GET_START: {
      const { directionType } = action;

      return {
        ...state,
        [directionType]: {
          ...state[directionType],
          status: LOADER.begin(),
        },
      };
    }
    case T.SUGGEST_GET_SUCCESS: {
      const { directionType, isTestResponse, points } = action;

      return {
        ...state,
        isTestResponse,
        [directionType]: {
          ...state[directionType],
          status: LOADER.success(),
          points,
        },
      };
    }
    case T.SUGGEST_GET_FAIL: {
      const { directionType, error } = action;

      return {
        ...state,
        [directionType]: {
          ...state[directionType],
          status: LOADER.error(error),
        },
      };
    }
    case T.SELECT_POINT: {
      const { directionType, pointObject } = action;

      return {
        ...state,
        [directionType]: {
          ...state[directionType],
          selectedPoint: { ...pointObject },
        },
      };
    }
    case T.RESET_SELECTED_POINT: {
      const { directionType } = action;

      return {
        ...state,
        [directionType]: {
          ...state[directionType],
          selectedPoint: {},
        },
      };
    }
    case T.RESET_ALL_POINTS: {
      const { directionType } = action;

      return {
        ...state,
        [directionType]: {
          ...state[directionType],
          points: [],
        },
      };
    }
    case T.ACTUAL_DIRECTION_VALUE: {
      const { directionType, actualValue } = action;

      return {
        ...state,
        [directionType]: {
          ...state[directionType],
          actualValue,
        },
      };
    }

    default:
      return state;
  }
};
